import { LENDER_ID } from "@app/types/regix";
import { REPAYMENT_COLLECTION_TYPE } from "@app/utils";

export const calPayableAmount = (selectedAmount:any,isFromForeclosure:boolean,lenderAccountId:string,foreClosureData:any,isFromClearDues: boolean) => {
    let amount = selectedAmount;
    const {outstandingCharges,advanceInterest,outstandingInterest,penalInterest,outstandingPrincipal} = foreClosureData;
    if(isFromClearDues === true){
        if(lenderAccountId?.toLowerCase() === LENDER_ID.TATA || lenderAccountId?.toLowerCase() === LENDER_ID.BAJAJ){
            amount = (outstandingCharges || 0) + (outstandingInterest || 0) + (outstandingPrincipal || 0) - (advanceInterest || 0)
        } else amount = (outstandingCharges || 0) + (outstandingInterest || 0) + (outstandingPrincipal || 0) + (penalInterest || 0) - (advanceInterest || 0)
    }
    if(amount>0 && amount <1 && lenderAccountId?.toLowerCase() === LENDER_ID.DSP && isFromForeclosure === true){
        amount = 1;
    }
    return amount;
}